import { render, staticRenderFns } from "./orderProductInfo.vue?vue&type=template&id=bd005600"
import script from "./orderProductInfo.vue?vue&type=script&lang=js"
export * from "./orderProductInfo.vue?vue&type=script&lang=js"
import style0 from "./orderProductInfo.vue?vue&type=style&index=0&id=bd005600&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports